angular.module("ainapp")
    .controller("employeeLoanController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", "LanguageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window, LanguageService) {

            $scope.PageName = "Employee Loan";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.LoanTypes = [];
            MainService.PayrollComponentsByType("Loans").then(function (response) {
                $scope.LoanTypes = response.data;
            });

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            });


            $scope.loadVoucher = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetEmployeeLoan($stateParams.VoucherId).then(function (response) {
                    if (response.data) {
                        $scope.empLoan = response.data;
                        $scope.empLoan.Date = new Date(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $.LoadingOverlay("hide");
                })
            }


            $scope.init = function () {
                console.log($scope.TokenInfo);

                $scope.empLoan = {

                    EmployeeId: "",
                    LoanTypeId: "",
                    Date: new Date(),
                    VoucherNo: "",
                    Remarks: "",
                    TotalAmount: 0,
                    ApprovedAmount: 0,
                    NoOfInstallments: 0,
                    InstallmentAmount: 0,
                    Year: "",
                    Month: "",
                    EmployeeLoanDetails: [],

                }

                var date = new Date();
                var mnt = date.getMonth() + 1;
                $scope.empLoan.Year = date.getFullYear();
                angular.forEach($scope.MonthsArr2, function (e) {
                    if (e.Id == mnt) {
                        $scope.empLoan.Month = e.Name;
                    }
                })



                if ($stateParams.VoucherId > 0) {
                    $scope.loadVoucher();
                } else {
                    MainService.GetNextEmployeeLoanNo().then(function (response) {
                        $scope.empLoan.VoucherNo = response.data;
                    });
                }


            }
            $scope.init();


            $scope.click = function () {

                if ($scope.empLoan.NoOfInstallments > 0 && $scope.empLoan.TotalAmount > 0) {
                    $scope.empLoan.InstallmentAmount = $scope.empLoan.TotalAmount / $scope.empLoan.NoOfInstallments;
                    $scope.empLoan.InstallmentAmount = Math.round($scope.empLoan.InstallmentAmount * 100) / 100;

                    var monthno = 0;
                    angular.forEach($scope.MonthsArr2, function (e) {
                        if (e.Name == $scope.empLoan.Month) {
                            monthno = e.Id;
                        }
                    })
                    var tdate = new Date(monthno + "/01/" + $scope.empLoan.Year);

                    $scope.empLoan.EmployeeLoanDetails = [];
                    for (var i = 0; i < $scope.empLoan.NoOfInstallments; i++) {

                        if (i == 0) {
                            var temp = {
                                Year: $scope.empLoan.Year,
                                Month: $scope.empLoan.Month,
                                Remarks: "",
                                Amount: $scope.empLoan.InstallmentAmount,
                            }
                        } else {

                            var ndate = new Date(tdate.setMonth(tdate.getMonth() + 1));
                            var mno = ndate.getMonth() + 1;
                            var yearno = ndate.getFullYear();
                            tdate = ndate;

                            var actmonth = "";
                            angular.forEach($scope.MonthsArr2, function (e) {
                                if (e.Id == mno) {
                                    actmonth = e.Name;
                                }
                            })

                            var temp = {
                                Year: yearno,
                                Month: actmonth,
                                Remarks: "",
                                Amount: $scope.empLoan.InstallmentAmount,
                            }

                        }

                        $scope.empLoan.EmployeeLoanDetails.push(temp);
                    }

                }

            }


            $scope.Delete = function (data) {
                $scope.SelectedDataForDelete = data;
                $('#deleteModal').modal('show');
            }

            $scope.deleteWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteEmployeeLoan($scope.empLoan.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $('#deleteModal').modal('hide');
                        $state.go("employeeLoanList");
                    } else {
                        toastr.warning("Failed");
                    }
                    $.LoadingOverlay("hide");
                    $scope.load = false;
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.SaveData = function () {

                //                else if ($scope.LeaveRequest.NoOfDays > $scope.LeaveRequest.AvailableLeaves) {
                //                    toastr.warning($scope.LanguageData.AvailableLeavesLessThanRequested);
                //                } 

                if ($scope.empLoan.EmployeeId == "") {
                    toastr.warning($scope.LanguageData.SelectEmployee);
                } else if ($scope.empLoan.LoanTypeId == "") {
                    toastr.warning("Select Loan Type");
                } else if ($scope.empLoan.NoOfInstallments <= 0) {
                    toastr.warning("Enter No Of Instalments");
                } else if ($scope.empLoan.TotalAmount <= 0) {
                    toastr.warning("Enter Total Amount");
                } else {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    $scope.empLoan.DateString = $scope.extractDate($scope.empLoan.Date);

                    MainService.addEmployeeLoan($scope.empLoan).then(function (response) {
                        if (response.data) {
                            toastr.success($scope.LanguageData.Success);
                            $scope.init();
                        } else {
                            toastr.error($scope.LanguageData.Error);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }



                }]);
